// 弹窗队列
export const setDialogs = dialogs => ({
  type: 'SET_DIALOG',
  dialogs,
});

// accountInfo
export const mapAppMainAccount = data => ({
  type: 'map_app_main_account',
  data,
});

// 日常任务
export const setDailyTask = dailyTask => ({
  type: 'SET_DAILYTASK',
  dailyTask,
});

// 用户现金金币信息
export const setMyIntegral = myIntegral => ({
  type: 'SET_MY_INTEGRAL',
  myIntegral,
});

// 邀请码绑定数据
export const setBindCodeData = bindCodeData => ({
  type: 'SET_BIND_CODE_DATA',
  bindCodeData,
});

// 签到数据
export const setSignTask = signTask => ({
  type: 'SET_SIGN_TASK',
  signTask,
});

// 是否老用户
export const setIsNewUser = isNewUser => ({
  type: 'SET_IS_NEW_USER',
  isNewUser,
});

// 按钮点击动作执行前的前置处理
export const setPreProcess = processList => ({
  type: 'SET_PRE_PROCESS',
  processList,
});

export const setCredit = credit => ({
  type: 'SET_CREDIT',
  credit,
});

// 是否有邀请模块
export const setHasInviteCard = hasInviteCard => ({
  type: 'SET_HAS_INVITE_CARD',
  hasInviteCard,
});

// 页面登录态
export const setIsLogin = isLogin => ({
  type: 'SET_IS_LOGIN',
  isLogin,
});

// 设置前端分桶
export const setTestBucket = testBucket => ({
  type: 'SET_TEST_BUCKET',
  testBucket,
});

// 设置是否展示狮子动画
export const setShowTaotie = isShowTaotie => ({
  type: 'SET_SHOW_TAOTIE',
  isShowTaotie,
});

export const setShowTaotieSwing = isShowTaotieSwing => ({
  type: 'SET_SHOW_TAOTIE_SWING',
  isShowTaotieSwing,
});

export const setShowPropertyTransAnim = propertyTransAnim => ({
  type: 'SHOW_PROPERTY_TRANS_ANIM',
  propertyTransAnim,
});

export const setNightMode = nightMode => ({
  type: 'SET_NIGHT_MODE',
  nightMode,
});

export const setWithdrawMiniNum = withdrawMiniNum => ({
  type: 'SET_WITHDRAW_MINI_NUM',
  withdrawMiniNum,
});

export const setSpringTask = springTask => ({
  type: 'SET_SPRING_TASK',
  springTask,
});

export const setCurTime = curTime => ({
  type: 'SET_CURTIME',
  curTime,
});

